__webpack_require__.p = "/whales_design/";